
<div class="flex-row-container m-b5" [ngClass]="viewMode==='SMALL'?'':'m-t10'"> 
  <span class="B flex-1 font20"></span>
  <button mat-stroked-button class="m-r10" [ngClass]="isDataChanged?'highlight-bg':''" color="primary" (click)="viewMode==='SMALL'?save():saveSelectedExpenses()">Save</button>
  <!-- <button *ngIf="goalType!=='LGY'" class="m-r10 font14" mat-stroked-button  color="primary" (click)="addExpense()">Add Expense</button> -->
  <button *ngIf="goalType!=='LGY'" [matMenuTriggerFor]="expensemenu" class="m-r10 font14" mat-stroked-button  color="primary">Add Expense</button>
  
</div>
<mat-table *ngIf="dataSource" [dataSource]="dataSource" class="tran-100"> 
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select" sticky>
      <mat-header-cell *matHeaderCellDef >
        <mat-checkbox  (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                      [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell   *matCellDef="let row" >
        <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selectionToggle(row) : null; updateSelectedExpensesInCache();"
                      [checked]="selection.isSelected(row)"
                      [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </mat-cell>
    </ng-container>
            
    <ng-container matColumnDef="expDesc" sticky>
      <mat-header-cell *matHeaderCellDef [ngClass]="viewMode!=='SMALL'?'expDescColumn':''"> EXPENSE </mat-header-cell>
      <!-- <mat-cell style="min-width: 20% !important"  *matCellDef="let element"> -->
      <!-- <mat-cell [ngStyle]="{'min-width': (viewMode==='SMALL') ?  '20% !important' : ''}"  *matCellDef="let element">         -->
      <mat-cell *matCellDef="let element" [ngClass]="viewMode!=='SMALL'?'expDescColumn':''">        
        <div class="flex-col-container" >
          <span>{{element.expDesc}}</span>
          <span  *ngIf="viewMode!=='SMALL'" class="font14 gray-color">{{element.goalDesc}}</span>
        </div>
      </mat-cell>                      
    </ng-container>

        <!-- <ng-container matColumnDef="legalEnityName">
            <mat-header-cell *matHeaderCellDef> Client Name (Person or Entity) </mat-header-cell>
            <mat-cell class="p-r10"  *matCellDef="let element"> {{element.LegalEntityName}} </mat-cell>
          </ng-container> -->
        
        <!-- <ng-container matColumnDef="owner">
          <mat-header-cell *matHeaderCellDef> OWNER </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.owner}} </mat-cell>
        </ng-container> -->
      
        <ng-container matColumnDef="amount">
          <mat-header-cell class="th-right" *matHeaderCellDef> ANNUAL COST </mat-header-cell>
          <mat-cell class="p-tb5 th-right" *matCellDef="let element"> 
            {{element.amount | currency:'USD': 'symbol' : '1.0-0'}}
          </mat-cell>
        </ng-container>
        
        <ng-container matColumnDef="growthType">
          <mat-header-cell class="th-right" *matHeaderCellDef> ANNUAL INFLATION </mat-header-cell>
          <mat-cell class="p-r10 p-tb5 th-right" *matCellDef="let element"> 
            <div class="flex-col-end">
                <span *ngIf="element.growthType==='INF'">Inflation</span>
                <span *ngIf="element.growthType==='MNF'">{{element.growthRate | number : '1.2-2'}}% </span>
                <!-- <span class="font14">{{element.growthType}}</span> -->
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="startYr">
            <mat-header-cell class="th-right" *matHeaderCellDef> START YEAR </mat-header-cell>
            <mat-cell class="p-tb5 th-right" *matCellDef="let element"> 
              {{element.startType==='AtEnd'?'Rest of Life':(element.startType==='AtRet'?'At Retirement':element.startYr)}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="endYr">
            <mat-header-cell class="th-right m-r25" *matHeaderCellDef> END YEAR </mat-header-cell>
            <mat-cell class="p-tb5 th-right m-r25" *matCellDef="let element"> 
              <!-- {{element.endType==='AtEnd'?'Rest of Life':(element.endType==='AtRet'?'At Retirement':element.endYr)}} -->
              {{element.endType==='Duration'?'No. of Years:':''}}
              {{element.endType==='Age'?'Age:':''}}
              {{element.endType==='AtEnd'?'Rest of Life':
                (element.endType==='AtRet'?'At Retirement':
                (element.endType==='Duration'?element.duration:
                (element.endType==='Age'?element.endAge:
                element.endYr)))}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell class="th-right" *matHeaderCellDef >              
            </mat-header-cell>
            <mat-cell class="th-right" *matCellDef="let element" >
                <mat-icon class="font18 m-l10 pointer" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Edit Expense" (click)="editExpense(element.expId)">edit</mat-icon>
                <mat-icon class="font18 m-l12 pointer" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Delete Expense"  (click)="deleteExpense(element.expId, element.expDesc)">delete</mat-icon>
            </mat-cell>
        </ng-container>
        
        <mat-header-row  [ngClass]="viewMode==='SMALL'?'display-none':''"  *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedColumns;">
        </mat-row>
</mat-table>


<mat-menu #expensemenu="matMenu">
  <ng-container *ngFor="let item of expenseTypeMenuItems">
    <button class="font14" mat-menu-item (click)="addExpense(item.code)"> {{item.value}}</button>    
  </ng-container> 
</mat-menu>

